
const rowStyle = {
  cursor: 'pointer',
};

const imageRow = {
  width: '50px',
};

export default {
  rowStyle,
  imageRow,
};



// WEBPACK FOOTER //
// ./src/scenes/Admins/components/AdminList/components/AdminRow/style.js